import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { UserAccountRoleEnum } from '../../api/types';
import { ApplicationState } from '../../app/store';
import { DashboardLayout } from '../../layouts/dashboard-layout/DashboardLayout';
import { ERouterPath } from '../../features/router/ERouterPath';
import { ISessionAppState } from '../../app/session/reducer';
import { PersonInput } from '../../features/add-person/AddPersonInput';

export const UpdatePerson = (): JSX.Element => {
  const { personId } = useParams<{ personId: string }>();
  const history = useHistory();
  const { user } = useSelector<ApplicationState, ISessionAppState>(state => state.session);
  const isAdmin = user?.accountRole && [UserAccountRoleEnum.administration, UserAccountRoleEnum.adminCaregiver].includes(user.accountRole);
  if (!isAdmin) {
    history.push(ERouterPath.home);
  }

  return (
    <DashboardLayout noTabs={true} backButton={true}>
      <PersonInput updatePersonId={+personId} />
    </DashboardLayout>
  );
};
